import React, { useEffect, useState } from "react";
import "./coursestep.css";
import {
  ChevronLeft,
  Pencil,
  Plus,
  PlusIcon,
  Trash,
  SquareCheckBig,
  CircleCheckBig,
  CircleCheck
} from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import { ShimmerThumbnail } from "react-shimmer-effects";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import ConfirmModal from "./ConfirmModal";
import AddImportantLink from "./AddImportantLink";
import EditImportantLink from "./EditImportantLink";
import AddResources from "./AddResources";
import EditResources from "./EditResources";

const CourseStep = () => {
  const navigate = useNavigate();
  let { currentStep } = useLocation().state || {};
  const { id, courseCode } = useLocation().state || {};
  const [loading, setLoading] = useState(true);
  const [fetchProgress, setFetchProgress] = useState(false)
  const [backModal, setBackModal] = useState(false)
  const [steps, setSteps] = useState([])
  const [selectedChapterIndex, setSelectedChapterIndex] = useState(0);
  const [addImportantLink, setAddImportantLink] = useState(false);
  const [editImportantLink, setEditImportantLink] = useState(false);
  const [importantLinkIndex, setImportantLinkIndex] = useState(0);
  const [importantLinkTitle, setImportantLinkTitle] = useState('');
  const [importantLinkURL, setImportantLinkUrl] = useState('');
  const [addResources, setAddResources] = useState(false);
  const [editResources, setEditResources] = useState(false);
  const [resourcesIndex, setResourcesIndex] = useState(null);
  const [resourcesTitle, setResourcesTitle] = useState('');
  const [resourcesURL, setResourcesUrl] = useState('');
  const userDetails = JSON.parse(localStorage.getItem('userDetails')) || null;

  const toggleImportantLink = () => {
    setAddImportantLink(!addImportantLink)
  }

  const toggleResources = () => {
    setAddResources(!addResources)
  }

  const toggleEditImportantLink = (index, title, url) => {
    setImportantLinkIndex(index);
    setImportantLinkTitle(title);
    setImportantLinkUrl(url);
    setEditImportantLink(!editImportantLink)
  }

  const toggleEditResources = (index, title, url) => {
    setResourcesIndex(index);
    setResourcesTitle(title);
    setResourcesUrl(url);
    setEditResources(!editResources)
  }

  const toggleBackModal = () => {
    if (steps[selectedChapterIndex] == 1) {
      navigate(-1);
    } else {
      setBackModal(!backModal)
    }
  }

  const handleVideoReady = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
  }, [selectedChapterIndex]);

  const markAsDone = async () => {
    try {
      const payload = {
        course_code: courseCode,
        step_index: currentStep.id - 1,
        chapter_index: selectedChapterIndex,
        status: 1,
      };
      const response = await apiServiceHandler(
        "PATCH",
        "api/courses/progress/update",
        { ...payload }
      );
      if (response.auth) {
        toastr.success(response.message);
        setSteps((prevSteps) =>
          prevSteps.map((step, index) =>
            index === selectedChapterIndex ? 1 : step
          )
        );
        // setFetchProgress(true);
      }
    } catch (error) {
      console.error(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getUserCourseProgress = async () => {
    try {
      const response = await apiServiceHandler("GET", `api/courses/progress?courseCode=${courseCode}`, {});
      const resStep = response?.courses_progress?.steps[currentStep.id - 1]?.chapters;
      setSteps(resStep);
      if (resStep.length > 0) {
        const firstTwoIndex = resStep.findIndex(step => step == 2);
        if (firstTwoIndex !== -1) {
          setSelectedChapterIndex(firstTwoIndex);
        }
      }
    } catch (error) {
      toastr.error(error.response?.data?.message);
      console.error("Something went wrong");
    }
  }

  useEffect(() => {
    getUserCourseProgress()
  }, [])

  useEffect(() => {
    if (fetchProgress) {
      getUserCourseProgress()
    }
    setFetchProgress(false)
  }, [fetchProgress])

  return (
    <div className="">
      <div className="page-step-content">
        {currentStep ? (
          <div className="page-section-elevated-header">
            {/* headers */}
            <div className="page-section-header">
              <div className="page-step-header">
                {/* eyebrow */}
                <div className="page-step-header-eyebrow">
                  <div className="course-step-view-eyebrow">
                    <button
                      className="back-button"
                      // onClick={() => navigate(-1)}
                      onClick={toggleBackModal}
                    >
                      <span className="icon">
                        <ChevronLeft size={32} />
                      </span>
                      <span className="button-label">Back</span>
                    </button>
                  </div>
                </div>
                <div className="board-page-header-top">
                  {/* step - heading */}
                  <div className="board-page-header-heading">
                    <div className="default-slot">
                      <div className="default-slot-content">
                        <span className="board-heading">
                          {currentStep.title}
                        </span>
                      </div>
                      {/*
                    <Pencil
                      fill="#d1b794"
                      color="#d1b794"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                    />
                    */}
                    </div>
                  </div>
                </div>
              </div>
              {/* step - description */}
              <div className="step-description">
                <div className="default-slot">
                  <div className="default-slot-content">
                    <p>{currentStep.description}</p>
                  </div>
                </div>
                {/*
              <Pencil
                fill="#d1b794"
                color="#d1b794"
                style={{
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                }}
              />
              */}
              </div>
            </div>
            <div className="page-section-body">
              <section className="course-step-view-page">
                <aside className="course-step-view-sidebar">
                  <div className="course-chapter-video-view-chapter-list">
                    <div className="course-chapter-list-items">
                      {currentStep.chapters.map((chapter, index) => (
                        <div
                          key={index}
                          className="chapter-list-item"
                          onClick={() => setSelectedChapterIndex(index)}
                        >
                          {selectedChapterIndex === index ? (
                            <span className="chapter-list-item-dot"></span>
                          ) : (
                            steps[index] === 1 && <span className="chapter-list-item-tick"></span>
                          )}
                          <span className="chapter-list-item-label">
                            <b>{index + 1}.</b> {chapter.title}
                          </span>
                        </div>
                      ))}
                      <div style={{}}>
                        {steps && steps[steps.length - 1] == 1 && (
                          <button
                            className="edit-content-btn"
                            onClick={() => navigate(-1)}
                            style={{ paddingLeft: '15px', fontSize: '15px' }}
                          >
                            <span className="edit-btn-label">[Continue To Next Section]</span>
                          </button>
                        )}
                      </div>
                    </div>
                    {/*
                  <div className="edit-chapter-action">
                    <button className="edit-btn">
                      <Pencil
                        fill="#d1b794"
                        color="#d1b794"
                        style={{
                          width: "15px",
                          height: "15px",
                          cursor: "pointer",
                          marginRight: "1rem",
                        }}
                      />
                      <span className="button-label"> Edit Chapters </span>
                    </button>
                  </div>
                  */}
                  </div>
                  <div className="card-default">
                    <div className="card-wrapper">
                      <div className="card-header">
                        <h2 className="card__heading">Resources</h2>
                        {userDetails && userDetails.admin && <button className="card-button" onClick={toggleResources}>
                          <Plus />
                        </button>}
                        {/* 
                      <button className="card-button">
                        <Plus />
                      </button>
                      */}
                      </div>
                      {/* <div className="card-content"> */}
                      <div>
                        {currentStep.resources.length > 0 ? (
                          (currentStep.resources.map((resourceItem, resourceIndex) => (
                            <div className="resources-list" key={resourceIndex}>
                              <div className="resource-link">
                                <div className="resource-name">
                                  {resourceIndex + 1}.&nbsp;
                                  <a
                                    href={resourceItem.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="download-resource-btn"
                                  >
                                    {resourceItem.title}
                                  </a>
                                </div>
                                {userDetails && userDetails.admin && <button className="card-button" style={{ border: 'none' }} onClick={() => toggleEditResources(resourceIndex, resourceItem.title, resourceItem.url)}>
                                  <Pencil />
                                </button>}
                              </div>
                            </div>
                          )))
                        ) : (
                          <div>No Step Resources</div>
                        )}
                      </div>
                      {/*
                      <div className="card-header">
                        <h2 className="card__heading">Important Link</h2>
                        {userDetails && userDetails.admin && <button className="card-button" onClick={toggleImportantLink}>
                          <Plus />
                        </button>}
                      </div>
                      <div className="card-content">
                        <div className="link-details">
                          {currentStep.important_link && currentStep.important_link.length > 0 ? (
                            currentStep.important_link.map((link, index) => (
                              <div className="resource-link" key={index}>
                                <div className="resource-name">
                                  {index + 1}.&nbsp;
                                  <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="download-resource-btn"
                                  >
                                    {link.title}
                                  </a>
                                </div>
                                {userDetails && userDetails.admin && <button className="card-button" style={{ border: 'none' }} onClick={() => toggleEditImportantLink(index, link.title, link.url)}>
                                  <Pencil />
                                </button>}
                              </div>
                            ))
                          ) : (
                            <div>No Link Available</div>
                          )}
                        </div>
                      </div>
                      */}
                    </div>
                  </div>
                </aside>
                <div className="course-chapter-view">
                  <div className="course-video-section">
                    {currentStep.chapters[selectedChapterIndex].video && <div>
                      <div className="video-player">
                        {currentStep.chapters[selectedChapterIndex] ? (
                          <div>
                            {/* 
                          {loading && (
                            <ShimmerThumbnail height={250} rounded />
                          )}
                          */}
                            <ReactPlayer
                              key={selectedChapterIndex}
                              url={
                                currentStep.chapters[selectedChapterIndex].video
                              }
                              config={{
                                vimeo: {
                                  playerOptions: {
                                    title: true,
                                    byline: false,
                                    portrait: false,
                                  },
                                },
                              }}
                              controls={true}
                              width="100%"
                              onReady={handleVideoReady}
                              onStart={() => setLoading(false)}
                            />
                          </div>
                        ) : (
                          <p>No video available</p>
                        )}
                      </div>
                    </div>}
                    <div className="course-chapter-edit-section">
                      {steps && steps[selectedChapterIndex] == 2 ? (
                        <button
                          className="edit-content-btn"
                          onClick={markAsDone}
                        >
                          <SquareCheckBig
                            // fill="#d1b794"
                            color="#d1b794"
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                            }}
                          />
                          <span className="edit-btn-label">Mark Done</span>
                        </button>
                      ) : (
                        <button className="disabled-content-btn">
                          <CircleCheckBig
                            color="#98bfde"
                            style={{
                              width: "16px",
                              height: "16px"
                            }}
                          />{" "}
                          <span className="disabled-btn-label">Completed</span>
                        </button>
                      )}
                    </div>
                    <div className="default-slot">
                      <div className="default-slot-content">
                        <div className="course-chapter-view-html">
                          <div
                            dangerouslySetInnerHTML={{ __html: currentStep?.chapters[selectedChapterIndex]?.description }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <p>Loading course...</p>
        )}
      </div>
      <ConfirmModal isOpen={backModal} onClose={toggleBackModal} />
      <AddImportantLink isOpen={addImportantLink} onClose={toggleImportantLink} id={id} stepIndex={steps[selectedChapterIndex] - 1} setFetchProgress={setFetchProgress} />
      <EditImportantLink isOpen={editImportantLink} onClose={toggleEditImportantLink} id={id} stepIndex={steps[selectedChapterIndex] - 1} linkIndex={importantLinkIndex} defaultTitle={importantLinkTitle} defaultLink={importantLinkURL} setFetchProgress={setFetchProgress} />
      <AddResources isOpen={addResources} onClose={toggleResources} id={id} stepIndex={currentStep.id - 1} setFetchProgress={setFetchProgress} />
      <EditResources isOpen={editResources} onClose={toggleEditResources} id={id} stepIndex={currentStep.id - 1} resourceIndex={resourcesIndex} defaultTitle={resourcesTitle} defaultLink={resourcesURL} setFetchProgress={setFetchProgress} />
    </div>
  );
};

export default CourseStep;
